<div class="bg-white">
  <!-- header -->
  <directory-portal-home-header></directory-portal-home-header>
  <!-- main -->
  <main class="">
    <!-- hero section -->
    <section class="bg-gray-50">
      <div
        class="max-w-macbook-screen mx-auto flex flex-col md:flex-row gap-x-16 gap-y-6 items-center bg-gray-50 py-8 sm:py-12 md:py-16 lg:py-20 xl:py-24 px-4 sm:px-8 md:px-12 lg:px-16 xl:px-20">
        <div class="space-y-6 flex-1 text-center">
          <h1
            i18n="@@home.hero.title"
            class="text-3xl/[125%] tracking-[-1%] text-gray-900 font-bold">
            Power Your Functional & Integrative Practice with One Intelligent
            Platform
          </h1>
          <p i18n="@@home.hero.subtitle" class="text-xl text-gray-500">
            Deliver better clinical outcomes, expand your clinical toolkit, and
            attract more patients, all with iCareDx
          </p>
          <button
            class="py-2.5 px-5 w-max rounded-lg bg-primary-700 text-white text-sm font-medium hover:bg-primary-800"
            i18n="@@home.hero.cta"
            (click)="onLearnMoreClick()">
            Click Here to Learn More
          </button>
        </div>
        <div class="flex-2 py-6 sm:py-0 relative">
          <picture>
            <source
              srcset="assets/directory-portal/home-hero-mobile.png"
              media="(max-width: 640px)" />
            <img src="assets/directory-portal/home-hero-desktop.png" alt="" />
          </picture>
          <div
            data-testid="promo-video-shell"
            class="absolute hidden md:block overflow-hidden"
            style="
              left: 6%;
              top: 0.5%;
              width: 88%;
              height: 91%;
              border-radius: 4px;
            ">
            <wistia-player
              class="block h-full w-full"
              media-id="fl4hntm6lf"
              aspect="1.7777777777777777"></wistia-player>
          </div>
        </div>
      </div>
    </section>
    <!-- features section -->
    <section
      class="py-8 sm:py-12 md:py-16 lg:py-20 xl:py-24 px-4 sm:px-8 md:px-12 lg:px-16 xl:px-20">
      <div class="grid gap-8 grid-cols-1 md:grid-cols-2 max-w-4xl mx-auto">
        @for (feature of features; track $index) {
          <div class="flex flex-col items-start max-w-md">
            <div
              class="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
              <mat-icon
                class="!w-6 !h-6 !text-primary-700"
                [svgIcon]="feature.image"></mat-icon>
            </div>

            <h3 class="mt-4 text-xl text-gray-900 font-bold">
              {{ feature.title }}
            </h3>
            <p class="mt-2 text-gray-500">{{ feature.description }}</p>
          </div>
        }
      </div>
    </section>
  </main>
  <!-- footer -->
  <directory-portal-home-footer></directory-portal-home-footer>
</div>
